import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from 'src/shared/components/Button';
import { color, font, layout } from 'src/shared/styles/variables';

import { navigationService } from 'src/config/rootService';
import termsImage from 'src/modules/admin/assets/terms.png';
import { config } from 'src/modules/admin/config/config';

const Wrapper = styled.div({
    backgroundColor: color.white,
    flexGrow: 1,
});

const ContentContainer = styled.div({
    width: 496,
});

const Content = styled.div({
    maxWidth: layout.containerWidth,
    margin: '0 auto',
    padding: '1rem 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 170,
});

const Title = styled.h1({
    fontWeight: 900,
    fontSize: font.size.extraLarge,
});

const Description = styled.p({
    fontSize: font.size.medium,
    lineHeight: '26px',
    letterSpacing: 'normal',
});

const ActionsContainer = styled.div({
    marginTop: 31,
    marginBottom: 18,
    button: {
        width: 240,
        paddingBottom: 12,
        paddingTop: 16,
    },
});

const Warning = styled.p({
    fontSize: font.size.medium,
    lineHeight: '26px',
    color: color.wildWatermelon,
});

const DocumentsLink = styled.a(
    {
        color: color.royalBlue,
        textDecoration: 'underline',
    },
    font.heavy(font.size.medium),
);

export const LATEST_TOU_VERSION = '07_30_2021';

export const AdminTerms = () => {
    const { t } = useTranslation();
    const [isWarningDisplayed, setWarningDisplayed] = useState(false);

    const handleDecline = () => {
        if (!isWarningDisplayed) {
            setWarningDisplayed(true);
            return;
        }

        navigationService.navigate('/dashboard');
    };

    const handleAccept = () => {
        localStorage.setItem(config.termsLocalStorageKey, LATEST_TOU_VERSION);
        navigationService.navigate('/admin');
    };

    return (
        <Wrapper>
            <Content>
                <ContentContainer>
                    <Title>{t('admin:terms.title')}</Title>
                    <Description>
                        <Trans
                            t={t}
                            ns="admin"
                            i18nKey="terms.description_one"
                            components={[
                                // eslint-disable-next-line react/jsx-key
                                <DocumentsLink href={config.lookerTermsUpdated} target="_blank" />,
                                // eslint-disable-next-line react/jsx-key
                                <DocumentsLink href={config.lookerTermsPrior} target="_blank" />,
                            ]}
                        />
                    </Description>
                    <Description>
                        <Trans t={t} ns="admin" i18nKey="terms.description_two" />
                    </Description>
                    <ActionsContainer>
                        <Button onClick={handleAccept} type="accept">
                            {t('admin:terms.agree')}
                        </Button>
                        <Button onClick={handleDecline} type="white2" marginLeft={16}>
                            {t('common.decline')}
                        </Button>
                    </ActionsContainer>
                    {isWarningDisplayed && (
                        <Warning data-testid="termsWarning">
                            <Trans t={t} ns={'admin'} i18nKey="terms.warning" />
                        </Warning>
                    )}
                </ContentContainer>
                <div>
                    <img src={termsImage} alt="guy reading terms list" />
                </div>
            </Content>
        </Wrapper>
    );
};
